export default __webpack_public_path__ + "static/media/buildSideProjects.501ec19f.jpg";